// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"afa2bd43","455":"b2b90e9f","977":"bcf42452"}[chunkId] + ".chunk.js";
};